export default __webpack_public_path__ + "static/media/ic_busd_40.8382b663.svg";